<template>
  <div class="bg-white relative">
    <div class="">
      <b-modal
        id="app-modal2"
        v-model="editModal"
        class="rounded-lg"
        centered
        hide-footer
        hide-header
      >
        <div class="relative">
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Cg-img/Frame%201000004955.png"
            alt="img"
            class="w-full h-full mx-auto rounded-2xl object-cover"
          />
          <div
            class="absolute h-8 px-8 flex items-center gap-4 bottom-8 left-0 w-full"
          >
            <div class="w-1/2 h-full" @click="appclick"></div>
            <div class="w-1/2 h-full" @click="playclick"></div>
          </div>
          <feather-icon
            icon="XIcon"
            svgClasses="w-5 h-5"
            class="absl top-2 right-2 p-1 clr-fff bg-3d3d3d61 rounded-full opacity-0"
            @click="editModal = false"
          />
        </div>
      </b-modal>
    </div>
    <CoverPage @cover-loaded="coverPageLoaded = true" />

    <!-- bg-templeteimg -->

    <template v-if="coverPageLoaded">
      <AboutUs />

      <div class="lg:mt-0 md:mt-0 mt-4">
        <WhoWeAre />
      </div>
      <div>
        <NeedHelp />
      </div>
      <SwiperCard />
      <Testimonials />
      <LatestGrid />
      <Announcement />
      <Partners />

      <Impact />

      <div class="bge3ceff-opa rounded-t-5555">
        <DownloadApp />
        <Footer />
        <b-modal
          id="translate-modal2"
          class="custom-sm-modal"
          hide-backdrop
          scrollable
          hide-footer
        >
          <template #modal-header>
            <h5 class="modal-title text-white">Translate site</h5>
            <b-button-close
              class="ml-auto"
              @click="$bvModal.hide('translate-modal2')"
            ></b-button-close>
          </template>
          <CGTranslator :countries="countries" @click="hideModal" />
          <!-- <Translator :countries="countries" @click="hideModal" /> -->
          <!-- <div
          class="m-5 grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 lg:gap-8 md:gap-8 gap-4"
        >
          <div v-for="item in countries" :key="item">
            <div class="w-full">
              <base-button
                type=""
                class="lg:py-2 md:py-2 py-1 px-8 fsize15 sm-fsize14 border-2 whitespacenowrap mx-auto w-full"
                >{{ item.title }}
              </base-button>
            </div>
          </div>
        </div> -->
          <!-- <GoogleTranslate
          default-language-code="en"
          default-page-language-code="en"
          :fetch-browser-language="false"
          trigger="click"
        /> -->
        </b-modal>
      </div>
    </template>
  </div>
</template>
<script>
import CoverPage from "./components/CoverPage.vue";
import AboutUs from "./components/AboutUsHome.vue";
import WhoWeAre from "./components/WhoWeAre.vue";
import NeedHelp from "./components/NeedHelp.vue";
import LatestGrid from "./components/LatestGrid.vue";
import Testimonials from "./components/Testimonials.vue";
import SwiperCard from "./components/SwiperCard.vue";
import Announcement from "./components/Announcement.vue";
import Partners from "./components/Partners.vue";
import Impact from "./components/Impact.vue";
import DownloadApp from "./components/DownloadApp.vue";
import Footer from "../Footer.vue";
import TranslateModal from "../navbar/components/TranslateModel.vue";
import { Translator } from "vue-google-translate";
import CGTranslator from "../navbar/components/GoogleTranslater.vue";
import TranslateModel from "../navbar/components/TranslateModel.vue";

// C:\brained\caregiver-saathi\src\views\navbar\components\TranslateModel.vuee

export default {
  components: {
    // GoogleTranslate,
    CGTranslator,
    CoverPage,
    AboutUs,
    WhoWeAre,
    NeedHelp,
    LatestGrid,
    Testimonials,
    SwiperCard,
    Announcement,
    Partners,
    Impact,
    DownloadApp,
    Footer,
    TranslateModal,
    Translator,
    TranslateModel,
  },
  data() {
    return {
      editModal: false,
      coverPageLoaded: false,
      countries: [
        {
          code: "en|hi",
          title: "हिन्दी",
          flagIconUrl: "https://flagicons.lipis.dev/flags/4x3/in.svg",
          altText: "Hindi language translation",
        },
        {
          code: "en|en",
          title: "English",
          flagIconUrl: "https://flagicons.lipis.dev/flags/4x3/gb.svg",
        },
      ],
    };
  },
  metaInfo: {
    title: "Caregiver Saathi Foundation: Companions for Caregivers",
    meta: [
      {
        name: "keyword",
        content: "Caregiver Saathi Foundation",
      },
      {
        name: "description",
        content:
          "Caregiver Saathi is a platform empowering people taking care of patients with chronis illnesses. We provide community support, counselling, home-care services & more.",
      },
    ],
  },
  methods: {
    playclick() {
      window.open(
        "https://play.google.com/store/apps/details?id=com.ceraproject&pcampaignid=web_share",
        "_blank"
      );
      console.log("object");
    },
    appclick() {
      window.open(
        "https://apps.apple.com/in/app/caregiver-saathi/id1640805488",
        "_blank"
      );
    },
    hideModal(data) {
      // if (typeof window !== "undefined") {
      //   window.doGTranslate(data);
      // }
      // console.log(data);
      // this.$bvModal.hide("translate-modal2");
      this.$bvModal.hide("translate-modal2");
    },
    handleModalChange(data) {
      // console.log("Hello")
    },
  },
  created() {
    // Show modal on mobile by default
    if (window.innerWidth <= 767) {
      this.editModal = true; // Or set based on any condition
    }
  },
  mounted() {
    // let visited = sessionStorage.getItem("visited");
    // if (!visited && !document.cookie.includes("googtrans")) {
    //   this.$bvModal.show("translate-modal2");
    // }
    // if (!visited) {
    //   sessionStorage.setItem("visited", true);
    // }
  },
};
</script>
<style>
.float-icon {
  width: 220px !important;
  height: 55px !important;
}
.top85 {
  top: 85%;
}
.modal-header {
  padding: 1rem !important;
}

.modal-header .close {
  padding: 0.5rem 1rem !important;
}

@media (max-width: 640px) {
  .smh-770px {
    height: 770px !important;
  }
  .p-0px {
    padding: 0px !important;
  }
}
#translate-modal2 .modal-dialog {
  max-width: 300px !important;
  margin: 1.75rem auto;
}

#translate-modal2 .modal-content {
  max-height: 200px !important;
  overflow-y: hidden;
}
.absl {
  position: absolute !important;
}
.bg-3d3d3d61 {
  background: #3d3d3d61;
}
#app-modal2 .modal-body {
  padding: 0px !important;
  border-radius: 1rem;
  overflow: hidden;
}
#app-modal2 .modal-content {
  background: transparent;
}
</style>
